export class ArcRoutes {

	public static readonly ArcRoot = 'map';

	public static readonly Compensation: string = '/compensation';

	public static readonly Employment: string = '/employment';

	public static readonly AddUnpaidLeave: string = '/add-unpaid-leave';

	public static readonly UnpaidLeaveOfAbsence: string = '/unpaid-leave-of-absence';

	public static readonly InstitutionDetails: string = '/details';

	public static readonly ScheduledPayment: string = '/scheduled-payment';

	public static readonly OneTimePayment: string = '/one-time-payment';

	public static readonly History: string = '/history';

	public static readonly InstitutionsAndGroups: string = '/institutions-and-groups';

	public static readonly ScheduledHours: string = '/scheduled-hours';

	public static readonly ScheduledHoursHistory: string = '/scheduled-hours-history';

	public static readonly Position: string = '/position';

	public static readonly Institution: string = '/institution2';

	public static readonly PlanSummary: string = '/plan-summary';

	public static readonly GhlDecline: string = '/declining-plans';

	public static readonly PlanHistory: string = '/plan-summary/plan-history';

	public static readonly DbPlanAdoption: string = '/db-plan-adoption';

	public static readonly QccoPlanAdoption: string = '/qcco-plan-adoption';

	public static readonly QccoPlanAmend: string = '/qcco-plan-amend';

	public static readonly QccoPlanIndemnify: string = '/qcco-plan-indemnify';

	public static readonly InstitutionRoot: string = '/institution';

	public static readonly DioceseRoot: string = '/diocese';

	public static readonly EmployeeList: string = '/employees';

	public static readonly InstitutionSurvey: string = '/institution-survey';

	public static readonly EmployeeSearch: string = '/select-an-employee';

	public static readonly InstitutionSearch: string = '/select-an-institution';

	public static readonly ManageInstitutionSearch: string = '/manage-institution-lists';

	public static readonly RequestNewIntitutionLanding: string = '/request-new-institution-landing';

	public static readonly GroupsLanding: string = '/groups-and-billing';

	public static readonly GroupSearch: string = '/select-a-group';

	public static readonly GroupAdminAdd: string = '/add-group-admin';

	public static readonly PeopleRoot: string = '/people';

	public static readonly BillingAccountsSearch: string = '/billing-accounts';

	public static readonly PersonalInformation: string = '/personal-information';

	public static readonly Participants: string = '/participants';

	public static readonly GroupAdministrators: string = '/administrators';

	public static readonly GroupDownloads: string = '/downloads';

	public static readonly InstitutionAdministratorSearch: string = '/institution-admins';

	public static readonly AddInstitutionAdministrator: string = '/add';

	public static readonly GroupAdminSearch: string = '/administrators';

	public static readonly Coverage: string = '/coverage';

	public static readonly PensionEnrollment: string = '/pension-enrollment';

	public static readonly NonStipNewHire: string = '/non-stip-new-hire';

	public static readonly StipNewHire: string = '/stip-new-hire';

	public static readonly NewHireConfirmation: string = '/new-hire-confirmation';

	public static readonly NonTecNonLicenseNewClergy: string = '/new-hire-not-allowed';

	public static readonly NewHireReview: string = '/new-hire-review';

	public static readonly EmploymentTermination: string = '/employment-termination';

	public static readonly EmploymentTerminationConfirmation: string = '/employment-termination-confirmation';

	public static readonly Notifications: string = '/notifications';

	public static readonly NewsUpdates: string = '/news-updates';

	public static readonly DNDPOC: string = '/dnd-poc';

	public static readonly PODSPOC: string = '/pods-poc';

	public static readonly LIFEINSURANCEPAGE: string = '/life-insurance-demo';

	public static readonly ReportSample: string = '/report-sample';

	public static readonly DocumentUpload: string = '/document-upload';

	public static readonly AuditLog: string = '/audit-log';

	public static readonly ReportsBenefitsGroup: string = '/reports';

	public static readonly ReportsBillingAccount: string = '/reports';

	public static readonly ReportsInstitution: string = '/reports';

    public static readonly ReportsDiocesan: string = '/diocesan-reports';

	public static readonly CompensationEmployment: string = '/compensation-employment';

	public static readonly MockApiApp: string = '/mock-api-app';

	public static readonly BenefitSurvey: string = '/benefit-survey';

	public static readonly EmployeeChangeLog: string = '/employee-change-log';

	public static readonly BenefitGroupChangeLog: string = '/benefit-group-change-log';

	public static readonly InstitutionAddRequest: string = '/add-request';

	public static readonly InstitutionAddRequestSubmitted: string = '/add-request-submitted';

	public static readonly InstitutionRemoveRequest: string = '/remove-request';

	public static readonly InstitutionRemoveRequestSubmitted: string = '/remove-request-submitted';

	public static readonly BenAdminPods: string = '/pods';

	public static readonly ClergyBio: string = '/clergy-bio';


	public static readonly BenAdminPodsNoSlash: string = 'pods';

	public static readonly NewHireEnrollment: string = '/new-hire-enrollment';

	public static readonly MemberNewHireEnrollment: string = '/new-hire-enrollment-member';

	public static readonly UpdateEnrollment: string = '/update-enrollment';

	public static readonly ParticipantEnrollment: string = '/participant-enrollment';

	public static readonly DioApproverEnrollment: string = '/dio-approver-enrollment';

	public static readonly Beneficiary: string = '/beneficiaries';

	public static readonly LifeEvents: string = '/life-events';

	public static readonly QualifyingEvent: string = '/qualifying-event';

	public static readonly CicOptInForm: string = 'electronic-document-delivery-agreement';

	public static readonly MycpgBilling: string = '/mycpg-billing';

}
